import React from "react";
import { IconButton } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CancelTwoToneIcon from "@mui/icons-material/CancelTwoTone";

import CustomDateFilterPicker from "./CustomDateFilterPicker";

const DateFilterGroup = ({ dateFilters, field, label, handleDateChange, handleClearFilter }) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <CustomDateFilterPicker
                dateFilters={dateFilters}
                field={field}
                startOrEnd={"start"}
                label={label}
                handleDateChange={handleDateChange}
            />
            <span>-</span>
            <CustomDateFilterPicker
                dateFilters={dateFilters}
                field={field}
                startOrEnd={"end"}
                handleDateChange={handleDateChange}
            />
            <IconButton
                onClick={() => handleClearFilter(field)}
                sx={{ width: "44px", height: "44px" }}
            >
                <CancelTwoToneIcon sx={{ color: "darkgray", fontSize: 28 }} />
            </IconButton>
        </LocalizationProvider>
    );
}

export default DateFilterGroup;